import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'primereact/button';

import styles from './DownloadPdf.module.scss';

interface DownloadPdfProps {
  generateAnotherPdf: () => void;
  downloadPdf: () => void;
}
const DownloadPdf: React.FC<DownloadPdfProps> = ({
  generateAnotherPdf,
  downloadPdf,
}) => {
  const { t } = useTranslation('cfe');

  return (
    <div className={styles.downloadPdf}>
      <div className={styles.textRow}>
        <FontAwesomeIcon icon={faCircleCheck} className={styles.icon} />
        <div>
          <h5>{t('invoiceGenerated')}</h5>
          <p>{t('electronicFiscalReceiptAvailability')}</p>
        </div>
      </div>
      <div className={styles.actionsRow}>
        <Button label="" link onClick={generateAnotherPdf}>
          <h5>{t('generateAnother')}</h5>
        </Button>
        <Button label="" link onClick={downloadPdf}>
          <h5>{t('downloadCFE')}</h5>
        </Button>
      </div>
    </div>
  );
};

export default DownloadPdf;
